"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");

var HtmlHelper = require("../shared/HtmlHelper");

class Frequency extends React.Component {
	constructor(props) {
		super(props);

		var selectedFrequency = null;
		var tangible = props[props.tangibleType];
		var frequencies = props.frequencies;
		var wizardFrequencies = { allowedFrequencies: [] };
		var frequency;
		var tangibleCode;
		var allowedFrequencies = [];
		var storeState = { isSponsorshipAvailable: true };

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			storeState = props.tangibleStore.getState();

			// Ideally we would get the tangible from the store, but that does not exist on the server
			// We optimistically render on the server with the props.tangible (the @Model) and on the
			//  client, we will get the tangible from the store
			tangible = storeState[props.tangibleType] || props[props.tangibleType] || {};
			tangible = JSON.parse(JSON.stringify(tangible)); // clone the tangible to avoid reference
			frequencies = props.frequencies ? props.frequencies.slice(0) : []; // clone the array to avoid reference

			// We only want to set the initial state from the store if we're not in a repeater.
			if (!props.context) {
				selectedFrequency = storeState.selectedFrequency;
			}

			wizardFrequencies = storeState.wizardFrequencies;
			if (wizardFrequencies) {
				allowedFrequencies = wizardFrequencies.allowedFrequencies || [];
			}
		}

		if (allowedFrequencies && frequencies) {
			for (var i = frequencies.length - 1; i >= 0; --i) {
				frequency = frequencies[i];
				var allowedIndex = allowedFrequencies.indexOf(frequency.value);
				if (allowedIndex === -1) {
					// Frequency is not allowed
					frequencies.splice(i, 1);
				} else if (frequency.useDefaultDescription) {
					// Frequency should use default description
					frequency.description = wizardFrequencies[`${frequency.value}_Description`];
				}
			}
		} else {
			frequencies = [];
		}

		if (!selectedFrequency) {
			if (frequencies && frequencies.length > 0) {
				selectedFrequency = frequencies[0].value;
			} else {
				selectedFrequency = "";
			}
		}

		if (props.context) {
			if (props[props.tangibleType]) {
				tangibleCode = props[props.tangibleType].tangibleCode;
			} else if (props.isDesignMode) {
				tangibleCode = tangible[props.displayCodeProperty];
			}
		}

		this.state = {
			selectedFrequency,
			tangible,
			tangibleCode,
			frequencies,
			isSponsorshipAvailable: storeState.isSponsorshipAvailable
		};

		this._onChange = this._onChange.bind(this);
	}

	handleFrequencySelected(event) {
		var selectedFrequency = event.currentTarget.value;

		this._setFrequency(selectedFrequency);
	}

	_setFrequency(selectedFrequency) {
		var { tangibleType } = this.props;

		// if we're handling a pledge frequency change, we need to send along the associated project code as well.
		if (tangibleType === "pledge")
		{
			var pledge = this.props[tangibleType];
			var projectCode = this.props.isDesignMode ? "PROJ001" : pledge ? pledge.displayObject.value["DefaultProjectCode"] : null;
			var isSecure = this.props.tangibleActions.getIsSecure();
			
			if ((pledge && projectCode) || isSecure) {
				this.props.tangibleActions.setFrequency(selectedFrequency, this.state.tangibleCode, projectCode, this.state.context);
			}
		} else {
			this.props.tangibleActions.setFrequency(selectedFrequency, this.state.tangibleCode, this.state.context);
		}
	}

	_onChange() {
		this.setState(this.props.tangibleStore.getState());
	}

	componentWillMount() {
		//Setting an instance Id, mainly for when we are in the searchResults and this component is in the grid and list view.  We need the names for the radio button groups to be unique.
		this.instanceId = HtmlHelper.getId($("body"));
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this.props.thisArg || this);
		}
		var context = this.props.context;
		var contextId = "";
		if (context) {
			switch (context) {
				case "tangible":
					context = "category";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=category]").attr("id");
					break;
				case "result":
					context = "search";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=searchResults]").attr("id");
					break;
			}
			context += `_${contextId}`;
		}

		var selectedFrequency = this.state.selectedFrequency;
		if (!context) {
			// Check sessionStorage for cachedValues
			var cachedValues = {};
			if (this.props.tangibleActions.getCachedValues) {
				cachedValues = this.props.tangibleActions.getCachedValues() || {};
			}

			if (cachedValues.frequency && this.state.frequencies.some(frequency => frequency.value === cachedValues.frequency)) {
				selectedFrequency = cachedValues.frequency;
			}
		}

		this.setState({ context }, () => {
		// At this point, selectedFrequency has been set by the component
			this._setFrequency(selectedFrequency);
		});
		this.props.tangibleStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		this.props.tangibleStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this.props.thisArg || this);
			this.props.tangibleActions.setFrequency(null, this.state.tangibleCode, this.state.context);
		}
	}

	renderButton(selectedFrequency) {
		var context = this.state.context;
		var name = `${context ? `frequency_${context}_${this.state.tangibleCode}` : "frequency"}_${this.instanceId}`;

		return (
			<div className="frequencies">
				{this.state.frequencies.map(frequency => {
					var isSelected = selectedFrequency === frequency.value;

					return (
						<label
								className={classNames(["frequency", "radio-button", this.props.childClass, { selected: isSelected }])}
								data-override-classes={this.props.childClass}
								key={frequency.value}
								data-component={`${this.props.beginningComponentName}ButtonFrequency.button`}
						>
							<input type="radio" name={name} value={frequency.value} onChange={this.handleFrequencySelected.bind(this)} checked={isSelected} />
							<span>{frequency.description}</span>
						</label>
					);
				})}
			</div>
		);
	}

	renderRadio(selectedFrequency) {
		var context = this.state.context;
		var name = `${context ? `frequency_${context}_${this.state.tangibleCode}` : "frequency"}_${this.instanceId}`;

		return (
			<div className="frequencies">
				{this.state.frequencies.map((frequency) => {
					var isSelected = selectedFrequency === frequency.value;

					return (
						<label
								className={classNames(["frequency", this.props.childClass, { selected: isSelected }])}
								data-override-classes={this.props.childClass}
								key={frequency.value}
								data-component={`${this.props.beginningComponentName}RadioFrequency.radio`}
						>
							<input type="radio" name={name} value={frequency.value} onChange={this.handleFrequencySelected.bind(this)} checked={isSelected} />
							<span data-component={`${this.props.beginningComponentName}RadioFrequency.radio.label`}>{frequency.description}</span>
						</label>
					);
				})}
			</div>
		);
	}

	renderDropdown(selectedFrequency) {
		return (
			<div>
				<select
						className={classNames(["donation-frequencies", this.props.childClass])}
						style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
						data-override-classes={this.props.childClass}
						selected={selectedFrequency}
						onChange={this.handleFrequencySelected.bind(this)}
						data-component={`${this.props.beginningComponentName}SelectFrequency.select`}
						value={selectedFrequency || ""}
				>
					{this.state.frequencies.map((frequency) => {
						return (
							<option className="frequency" key={frequency.value} value={frequency.value}>
								{frequency.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	}

	renderContainer() {
		var selectedFrequency;
		if (this.state.context) {
			selectedFrequency = this.props.tangibleStore.getSelectedFrequency(this.state.context, this.state.tangibleCode);
		} else {
			selectedFrequency = this.state.selectedFrequency;
		}

		switch (this.props.type) {
			case "button":
				return this.renderButton(selectedFrequency);
			case "radio":
				return this.renderRadio(selectedFrequency);
			case "dropdown":
				return this.renderDropdown(selectedFrequency);
			default:
				console.error("Invalid type for Frequency");
				return null;
		}
	}

	render() {
		var frequencies = this.state.frequencies;
		var tangible = this.state.tangible || {};
		var reactComponentName;

		if (tangible.PledgeType === "CHILD" && !this.state.isSponsorshipAvailable) {
			return null;
		}

		switch (this.props.type) {
			case "button":
				reactComponentName = "ButtonFrequency";
				break;
			case "radio":
				reactComponentName = "RadioFrequency";
				break;
			case "dropdown":
				reactComponentName = "SelectFrequency";
				break;
			default:
				console.error("Invalid type for Frequency");
				return null;
		}
		reactComponentName = this.props.beginningComponentName + reactComponentName;

		return (
			<div
				className="frequency"
				data-react-component-name={reactComponentName}
				data-react-component-category={this.props.reactComponentCategory}
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
				tabIndex={this.props.isDesignMode ? -1 : undefined}
			>
				{frequencies && frequencies.length > 0 ?
					this.renderContainer()
				:
					<div className="collapsedComponentPlaceholder">{reactComponentName}</div>
				}
			</div>
		);
	}
}

Frequency.defaultProps = {
	beginningComponentName: "",
	type: "button",
	theme: "0",
	isCustomTheme: false
};

Frequency.propTypes = {
	isDesignMode: PropTypes.bool, //can do .isRequired
	tangible: PropTypes.object,
	frequencies: PropTypes.array,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]),
	context: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,

	tangibleActions: PropTypes.object,
	tangibleStore: PropTypes.object,
	thisArg: PropTypes.object,
	tangibleType: PropTypes.string,
	displayCodeProperty: PropTypes.string,
	reactComponentCategory: PropTypes.string,
	beginningComponentName: PropTypes.string
};

module.exports = Frequency;
